<template>
  <div class="rt-header-title-wrapper">
    <div class="header-title">{{ title }}</div>
    <div class="header-sub-title-wrapper">
      <span v-if="subTitle" class="header-sub-title">{{ subTitle }}</span>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'RtHeaderTitle',
  props: {
    title: {
      type: String,
      required: true
    },
    subTitle: {
      type: String,
      default: ''
    }
  }
};
</script>
<style lang="less">
.rt-header-title-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  .header-title {
    color: #143e81;
    font-size: 18px;
    font-weight: 600;
    // margin-top: 4px;
  }
  .header-sub-title-wrapper {
    display: flex;
    align-items: center;
    margin-top: 11px;
    span.header-sub-title {
      color: #6388c2;
      font-size: 14px;
      margin-right: 12px;
      font-weight: 500;
    }
  }
}
</style>



// WEBPACK FOOTER //
// rtHeaderTitle.vue?668e5680